import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { getDocumentCategoryName } from '../data/store/Root'
import { dateFormatter, DateFormatTypes, getDescriptionFromLOVValue, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

export const findRiskSettingValue = (riskLimits, configType, key, defaultVal = undefined) => {
  const value = riskLimits?.find((item) => item?.configType === configType && item?.key === key)?.value
  if (value === 'N') {
    return 'No'
  } else if (value === 'Y') {
    return 'Yes'
  }
  return value ?? defaultVal
}

export const getLimitTableData = (riskLimits: any) => {
  const configType = 'OPEN_LOOP_RISK'
  const keyStarting = 'OPEN_LOOP_'
  return [
    {
      current: '',
      previous: findRiskSettingValue(riskLimits, configType, keyStarting + 'PREVIOUS_TRANSACTION_LIMIT', 'NA'),
      older: findRiskSettingValue(riskLimits, configType, keyStarting + 'OLDER_TRANSACTION_LIMIT', 'NA'),
      recruitment: findRiskSettingValue(riskLimits, configType, keyStarting + 'RECRUITMENT_TRANSACTION_LIMIT', 'NA'),
    },
    {
      current: '',
      previous: findRiskSettingValue(riskLimits, configType, keyStarting + 'PREVIOUS_EXIT_LIMIT', 'NA'),
      older: findRiskSettingValue(riskLimits, configType, keyStarting + 'OLDER_EXIT_LIMIT', 'NA'),
      recruitment: findRiskSettingValue(riskLimits, configType, keyStarting + 'RECRUITMENT_EXIT_LIMIT', 'NA'),
    },
    {
      current: '',
      previous: findRiskSettingValue(riskLimits, configType, keyStarting + 'PREVIOUS_TRANSACTION_COUNT', 'NA'),
      older: findRiskSettingValue(riskLimits, configType, keyStarting + 'OLDER_TRANSACTION_COUNT', 'NA'),
      recruitment: findRiskSettingValue(riskLimits, configType, keyStarting + 'RECRUITMENT_TRANSACTION_COUNT', 'NA'),
    },
    {
      current: findRiskSettingValue(riskLimits, configType, keyStarting + 'CURRENT_RISK_SCORE', 'NA'),
      previous: findRiskSettingValue(riskLimits, configType, keyStarting + 'PREVIOUS_RISK_SCORE', 'NA'),
      older: findRiskSettingValue(riskLimits, configType, keyStarting + 'OLDER_RISK_SCORE', 'NA'),
      recruitment: findRiskSettingValue(riskLimits, configType, keyStarting + 'RECRUITMENT_RISK_SCORE', 'NA'),
    },
  ]
}

const formatDocList = (docList: any[], isCategoryRequired = false) =>
  docList
    ?.filter((item) => !item?.merchantDocumentType)
    ?.map((item) => ({
      ...(isCategoryRequired ? { MERCHANT_DOCUMENT_TYPE: item.documentCategory } : {}),
      NAME: item?.fileName,
      MERCHANT_DOCUMENT_NAME: getDocumentCategoryName(item?.documentType, RootStore.documentCategories) ?? 'NA',
      RID: item?.documentId,
      expiry: item?.expiryDate,
      documentNumber: item?.number,
      uploadId: item?.documentUploadId,
    }))

const formatJdmsData = (data: any) =>
  data
    ?.filter((item) => item?.merchantDocumentType)
    ?.map((item) => ({
      documentCategory: item?.documentCategory ?? 'NA',
      MERCHANT_DOCUMENT_TYPE: item?.documentCategory ?? '',
      documentId: getDocumentCategoryName(item?.documentType, RootStore.documentCategories) ?? 'NA',
      documentNumber: item?.number ?? 'NA',
      dateOfExpiry: item?.expiryDate ?? 'NA',
      view_: 'View_View',
      kycDocuments: [
        {
          DOCID: undefined,
          NAME: item?.fileName,
          MERCHANT_DOCUMENT_TYPE: item?.merchantDocumentType,
          DOCUMENTSTATUS: undefined,
          RID: undefined,
          TRANSACTION_ID: undefined,
        },
      ],
    }))

export const parseEntityItem = (item, ddData: any, defaultVal = undefined) => {
  const authSignatoryPoi_docs_data: any = formatDocList(item?.merchant?.authorizedSignatoryList?.[0]?.poi ?? [], false)
  const authSignatoryPoA_docs_data: any = formatDocList(item?.merchant?.authorizedSignatoryList?.[0]?.poa ?? [], false)
  const businessDetailsPob_docs_data: any = formatDocList(item?.merchant?.businessDetails?.pob ?? [])
  console.log('htag item?.merchant?.status?.statusCode', item?.merchant?.status?.statusCode)
  console.log(
    'htag item?.merchant?.status?.statusCode val',
    getDescriptionFromLOVValue(ddData?.lovData, 'Status', item?.merchant?.status?.statusCode, defaultVal),
  )
  console.log('htag item?.merchant?.status?.statusCode val', ddData)
  return {
    applicationId: item?.applicationId ?? item?.workflowId,
    entityId: item?.merchant?.entityIdentificationNumber,
    taskInstanceId: item?.taskInstanceId,
    requestType: item?.requestType,
    createdAt: dateFormatter(item?.createdAt, DateFormatTypes.DATE_AM_PM),
    documentUploadId: item?.merchant?.documentUploadId,
    applicationStatus: item?.applicationState ?? item?.workflowState,
    merchantType: item?.merchant?.type,
    entityIdentificationNumber: item?.merchant?.entityIdentificationNumber,
    parentEntityId: item?.merchant?.parentEntityIdentificationNumber,
    parentGroupId: item?.merchant?.groupId,
    parentSubGroupId: item?.merchant?.subGroupId,
    onboardingChannel: getDescriptionFromLOVValue(
      ddData?.lovData,
      'SetupCompleteInd',
      item?.merchant?.onboardingChannel,
      defaultVal,
    ),
    parentType: item?.merchant?.parentEntityIdentificationNumber ? 'Entity' : 'SubGroup',
    nonEditableParentDetails: item?.merchant?.subGroupId,
    terminals: item?.merchant?.terminals ?? [],
    status: getDescriptionFromLOVValue(ddData?.lovData, 'Status', item?.merchant?.status?.statusCode, defaultVal),

    reasonCode: getDescriptionFromLOVValue(
      ddData?.lovData,
      'ReasonCode',
      item?.merchant?.status?.reasonCode,
      defaultVal,
    ),

    reasonMessage: item?.merchant?.status?.reasonMessage,
    personalFirstName: item?.merchant?.primaryContactDetail?.name?.firstName,
    personalLastName: item?.merchant?.primaryContactDetail?.name?.lastName,
    personalMobileNumber: item?.merchant?.primaryContactDetail?.mobileNumber?.mobileNumber,
    personalEmailId: item?.merchant?.primaryContactDetail?.emailId,
    entityType: getDescriptionFromLOVValue(
      ddData?.lovData,
      'OwnerType',
      item?.merchant?.businessDetails?.businessType,
      defaultVal,
    ),
    ownershipType: getDescriptionFromLOVValue(
      ddData?.lovData,
      'OwnershipType',
      item?.merchant?.businessDetails?.businessOwnershipType,
      defaultVal,
    ),
    businessChannel: getDescriptionFromLOVValue(
      ddData?.lovData,
      'BusinessChannel',
      item?.merchant?.businessDetails?.businessChannel,
      defaultVal,
    ),
    storeCode: item?.merchant?.businessDetails?.storeCodeDetail?.storeCode,
    format: item?.merchant?.businessDetails?.storeCodeDetail?.format,
    authSignatoryFirstName: item?.merchant?.authorizedSignatoryList?.[0]?.name?.firstName,
    authSignatoryLastName: item?.merchant?.authorizedSignatoryList?.[0]?.name?.lastName,
    authSignatoryDateOfBirth: parseDate(item?.merchant?.authorizedSignatoryList?.[0]?.dateOfBirth),
    authSignatoryGender: getDescriptionFromLOVValue(
      ddData?.lovData,
      'Gender',
      item?.merchant?.authorizedSignatoryList?.[0]?.gender,
      defaultVal,
    ),
    authSignatoryPan: item?.merchant?.authorizedSignatoryList?.[0]?.pan,
    authSignatoryPoiType: authSignatoryPoi_docs_data?.[0]?.MERCHANT_DOCUMENT_NAME,
    authSignatoryPoiId: authSignatoryPoi_docs_data?.[0]?.documentNumber,
    authSignatoryPoiExpiryDate: authSignatoryPoi_docs_data?.[0]?.expiry,
    authSignatoryPoi_docs_data_jdms: formatJdmsData(item?.merchant?.authorizedSignatoryList?.[0]?.poi),
    authSignatoryPoi_docs_data,
    authSignatoryPoaType: authSignatoryPoA_docs_data?.[0]?.MERCHANT_DOCUMENT_NAME,
    authSignatoryPoaId: authSignatoryPoA_docs_data?.[0]?.documentNumber,
    authSignatoryPoaExpiryDate: authSignatoryPoA_docs_data?.[0]?.expiry,
    authSignatoryPoA_docs_data_jdms: formatJdmsData(item?.merchant?.authorizedSignatoryList?.[0]?.poa),
    authSignatoryPoA_docs_data,
    authSignatoryAddressLine1: item?.merchant?.authorizedSignatoryList?.[0]?.address?.addressLine1,
    authSignatoryAddressLine2: item?.merchant?.authorizedSignatoryList?.[0]?.address?.addressLine2,
    authSignatoryPincode: item?.merchant?.authorizedSignatoryList?.[0]?.address?.pinCode,
    authSignatoryCity: item?.merchant?.authorizedSignatoryList?.[0]?.address?.city,
    authSignatoryState: getDescriptionFromLOVValue(
      ddData?.lovData,
      'State',
      item?.merchant?.authorizedSignatoryList?.[0]?.address?.state,
      defaultVal,
    ),
    businessDisplayName: item?.merchant?.businessDetails?.displayName,
    businessLegalName: item?.merchant?.businessDetails?.legalName,
    businessPan: item?.merchant?.businessDetails?.businessPan,
    storeType: getDescriptionFromLOVValue(
      ddData?.lovData,
      'StoreType',
      item?.merchant?.businessDetails?.storeAddressType,
      defaultVal,
    ),
    mccCodeComponent: {
      businessLine: {
        key: item?.merchant?.businessDetails?.businessLine,
        value: '',
      },
      businessCategory: item?.merchant?.businessDetails?.businessCategory,
      mccCode: item?.merchant?.businessDetails?.mcc?.mcc,
    },
    cinNumber: item?.merchant?.businessDetails?.cin,
    companyIncorporatedDate: parseDate(item?.merchant?.businessDetails?.incorporatedDate),
    yearsOfBusiness: getDescriptionFromLOVValue(
      ddData?.lovData,
      'YearsInBusiness',
      item?.merchant?.businessDetails?.yearsInBusiness,
      defaultVal,
    ),
    gstCategory: getDescriptionFromLOVValue(
      ddData?.lovData,
      'MerchantCategory',
      item?.merchant?.gstDetails?.category,
      defaultVal,
    ),

    gstinNumber: item?.merchant?.gstDetails?.number,
    confirmGstinNumber: item?.merchant?.gstDetails?.number,
    gstDealerCategory: getDescriptionFromLOVValue(
      ddData?.lovData,
      'GSTDealerCategory',
      item?.merchant?.gstDetails?.dealerCategory,
      defaultVal,
    ),
    typeOfBusiness: getDescriptionFromLOVValue(
      ddData?.lovData,
      'BusinessType',
      item?.merchant?.gstDetails?.typeOfBusiness,
      defaultVal,
    ),
    pobDocType: businessDetailsPob_docs_data?.[0]?.MERCHANT_DOCUMENT_NAME,
    pobId: businessDetailsPob_docs_data?.[0]?.documentNumber,
    pobExpiryDate: businessDetailsPob_docs_data?.[0]?.expiry,
    businessDetailsPob_docs_data,
    businessDetailsPob_docs_data_jdms: formatJdmsData(item?.merchant?.businessDetails?.pob),
    gstinState: item?.merchant?.gstDetails?.state,

    premiseType: getDescriptionFromLOVValue(
      ddData?.lovData,
      'PremiseType',
      item?.merchant?.businessDetails?.businessAddressType,
      defaultVal,
    ),
    addressLine1: item?.merchant?.businessDetails?.businessAddress?.addressLine1,
    addressLine2: item?.merchant?.businessDetails?.businessAddress?.addressLine2,
    pincode: item?.merchant?.businessDetails?.businessAddress?.pinCode,
    city: item?.merchant?.businessDetails?.businessAddress?.city,
    state: getDescriptionFromLOVValue(
      ddData?.lovData,
      'State',
      item?.merchant?.businessDetails?.businessAddress?.state,
      defaultVal,
    ),
    businessWebsite: item?.merchant?.otherBusinessDetails?.website,
    landlineNumber: item?.merchant?.otherBusinessDetails?.landlineNumber,
    businessEmailId: item?.merchant?.otherBusinessDetails?.emailId,
    dailyTransactionValue: getDescriptionFromLOVValue(
      ddData?.lovData,
      'DailyTransactionValue',
      item?.merchant?.otherBusinessDetails?.dailyTransactionValue,
      item?.merchant?.otherBusinessDetails?.dailyTransactionValue || '',
    ),
    dailyTransactionCount: getDescriptionFromLOVValue(
      ddData?.lovData,
      'DailyTransactionVolume',
      item?.merchant?.otherBusinessDetails?.dailyTransactionCount,
      item?.merchant?.otherBusinessDetails?.dailyTransactionCount || '',
    ),
    // returnPolicy: getDescriptionFromLOVValue(
    //   ddData?.lovData,
    //   'ReturnPolicy',
    //   item?.merchant?.otherBusinessDetails?.returnPolicy,
    //   defaultVal,
    // ),
    bankAccountHolderName: item?.merchant?.settlementDetail?.beneficiaryName,
    settlementAccountNumber: item?.merchant?.settlementDetail?.accountNumber,
    confirmSettlementAccountNumber: item?.merchant?.settlementDetail?.accountNumber,
    ifscCode: item?.merchant?.settlementDetail?.ifscCode,
    account_proof_docType: 'Cancelled Cheque',
    canceled_check_docs_data: formatDocList(item?.merchant?.settlementDetail?.documents ?? [], true),
    canceled_check_docs_data_jdms: formatJdmsData(item?.merchant?.settlementDetail?.documents),
    settlementFrequency: getDescriptionFromLOVValue(
      ddData?.lovData,
      'SettlementFrequencyESS',
      item?.merchant?.settlementDetail?.settlementPlanId + '',
      defaultVal,
    ),
    settlementPlanId: item?.merchant?.settlementDetail?.settlementPlanId,
    doc_upload_docs_data: formatDocList(item?.merchant?.documents ?? [], true),
    doc_upload_docs_data_jdms: formatJdmsData(item?.merchant?.documents),
    feePackageId: item?.merchant?.feePackage?.feePackageId,
    allowParentFeePackageId: item?.merchant?.feePackage?.inheritParentFeePackage ? 'Yes' : 'No',
    listOfPrograms: item?.merchant?.feePackage?.programs?.[0]?.programId,
    referenceId: item?.merchant?.feePackage?.programs?.[0]?.programReferenceId,
    riskAllowTip: findRiskSettingValue(item?.merchant?.riskSettings?.configMap, 'RISK_SETTING', 'TIP'),
    merchantRiskCategory: findRiskSettingValue(
      item?.merchant?.riskSettings?.configMap,
      'RISK_SETTING',
      'MERCHANT_RISK',
    ),
    allowParentIdSettlement: findRiskSettingValue(
      item?.merchant?.riskSettings?.configMap,
      'RISK_SETTING',
      'ALLOW_PARENT_ID_SETTL_FLAG',
    ),
    riskDeliveryPeriod: getDescriptionFromLOVValue(
      ddData?.lovData,
      'DeliveryMode',
      findRiskSettingValue(item?.merchant?.riskSettings?.configMap, 'RISK_SETTING', 'DELIVERY_PERIOD'),
      '',
    ),
    riskDeferredDeliveryOptions: getDescriptionFromLOVValue(
      ddData?.lovData,
      'DeferredDeliveryOptions',
      findRiskSettingValue(item?.merchant?.riskSettings?.configMap, 'RISK_SETTING', 'MERCHANT_DAY_DELIVERY'),
      '',
    ),
    riskInternationalAcceptance: findRiskSettingValue(
      item?.merchant?.riskSettings?.configMap,
      'RISK_SETTING',
      'INTERNATIONAL_ACCEPTANCE',
    ),
    riskCurrentTnxLimit: findRiskSettingValue(
      item?.merchant?.riskSettings?.limits,
      'OPEN_LOOP_RISK',
      'OPEN_LOOP_CURRENT_TRANSACTION_LIMIT',
    ),
    riskCurrentExitLimit: findRiskSettingValue(
      item?.merchant?.riskSettings?.limits,
      'OPEN_LOOP_RISK',
      'OPEN_LOOP_CURRENT_EXIT_LIMIT',
    ),
    riskCurrentTnxCount: findRiskSettingValue(
      item?.merchant?.riskSettings?.limits,
      'OPEN_LOOP_RISK',
      'OPEN_LOOP_CURRENT_TRANSACTION_COUNT',
    ),
    limitTableData: getLimitTableData(item?.merchant?.riskSettings?.limits),
    risk_supporting_docs_data: formatDocList(item?.merchant?.riskSettings?.documents ?? [], true),
    risk_supporting_docs_data_jdms: formatJdmsData(item?.merchant?.riskSettings?.documents),
    changeHistory: getChangeHistory(item?.changesHistory, ddData, item?.merchant?.riskSettings),
    opsComments: item?.opsComments,
    riskCommentForOps: item?.riskCommentForOps,
    riskInternalComment: item?.riskInternalComment,
    skipDedupe: item?.skipDedupe,
    riskSettings: item?.merchant?.riskSettings,
    configMap: item?.merchant?.configMap,
    configList: item?.merchant?.configList,
    feePackageReferenceId: item?.merchant?.feePackage?.id,
    settlementDetailId: item?.merchant?.settlementDetail?.id,
    businessDetailsAddressId: item?.merchant?.businessDetails?.businessAddress?.id,
    gstDetailsId: item?.merchant?.gstDetails?.id,
    businessDetailsId: item?.merchant?.businessDetails?.id,
    authorisedSignatoryAddressId: item?.merchant?.authorizedSignatoryList?.[0]?.address?.id,
    authorisedSignatoryReferenceId: item?.merchant?.authorizedSignatoryList?.[0].authorisedSignatoryReferenceId,
    originalMerchant: item?.originalMerchant,
  }
}

export const entityListResponseParser = (response: any, ddData: any) => {
  console.log('response=', response)
  const data = isSuccessResponse(response)
  console.log('response data =', response)

  return {
    data: data?.processInstances?.map((item) => parseEntityItem(item, ddData)) ?? [],
    pagination: {
      size: data?.pageSize,
      totalElements: data?.totalItems ?? 0,
      number: data?.pageNumber + 1,
      totalPages: Math.ceil(data?.totalItems / data?.pageSize),
    },
  }
}

const getChangeHistory = (changeHistory: any, ddData: any, originalRiskSettings): any => {
  const configMap = changeHistory?.riskSettings?.configMap?.map((configs, index) => ({
    ...originalRiskSettings.configMap[index],
    value: configs?.value,
  }))
  const limits = changeHistory?.riskSettings?.limits?.map((limit, index) => ({
    ...originalRiskSettings.limits[index],
    value: limit?.value,
  }))
  return {
    parentEntityId: changeHistory?.parentEntityIdentificationNumber,
    parentGroupId: changeHistory?.groupId,
    parentSubGroupId: changeHistory?.subGroupId,
    personalFirstName: changeHistory?.primaryContactDetail?.name?.firstName,
    personalLastName: changeHistory?.primaryContactDetail?.name?.lastName,
    personalMobileNumber: changeHistory?.primaryContactDetail?.mobileNumber?.mobileNumber,
    personalEmailId: changeHistory?.primaryContactDetail?.emailId,
    entityType: changeHistory?.businessDetails?.businessType,
    ownershipType: changeHistory?.businessDetails?.businessOwnershipType,
    businessChannel: changeHistory?.businessDetails?.businessChannel,
    storeCode: changeHistory?.businessDetails?.storeCodeDetail?.storeCode,
    format: changeHistory?.businessDetails?.storeCodeDetail?.format,
    authSignatoryFirstName: changeHistory?.authorizedSignatoryList?.[0]?.name?.firstName,
    authSignatoryLastName: changeHistory?.authorizedSignatoryList?.[0]?.name?.lastName,
    authSignatoryDateOfBirth: changeHistory?.authorizedSignatoryList?.[0]?.dateOfBirth,
    authSignatoryGender: changeHistory?.authorizedSignatoryList?.[0]?.gender,
    authSignatoryPan: changeHistory?.authorizedSignatoryList?.[0]?.pan,
    authSignatoryPoi_docs_data: changeHistory?.authorizedSignatoryList?.[0]?.poi,
    authSignatoryPoA_docs_data: changeHistory?.authorizedSignatoryList?.[0]?.poa,
    authSignatoryAddressLine1: changeHistory?.authorizedSignatoryList?.[0]?.address?.addressLine1,
    authSignatoryAddressLine2: changeHistory?.authorizedSignatoryList?.[0]?.address?.addressLine2,
    authSignatoryPincode: changeHistory?.authorizedSignatoryList?.[0]?.address?.pinCode,
    authSignatoryCity: changeHistory?.authorizedSignatoryList?.[0]?.address?.city,
    authSignatoryState: changeHistory?.authorizedSignatoryList?.[0]?.address?.state,
    businessDisplayName: changeHistory?.businessDetails?.displayName,
    businessLegalName: changeHistory?.businessDetails?.legalName,
    businessPan: changeHistory?.businessDetails?.businessPan,
    storeType: changeHistory?.businessDetails?.storeAddressType,
    mccCodeComponent: {
      businessLine: [],
      businessCategory: [],
      mccCode: changeHistory?.businessDetails?.mcc?.mcc,
    },
    cinNumber: changeHistory?.businessDetails?.cin,
    companyIncorporatedDate: changeHistory?.businessDetails?.incorporatedDate,
    yearsOfBusiness: changeHistory?.businessDetails?.yearsInBusiness,
    gstCategory: changeHistory?.gstDetails?.category,
    gstinNumber: changeHistory?.gstDetails?.number,
    confirmGstinNumber: changeHistory?.gstDetails?.number,
    gstDealerCategory: changeHistory?.gstDetails?.dealerCategory,
    typeOfBusiness: changeHistory?.gstDetails?.typeOfBusiness,
    businessDetailsPob_docs_data: changeHistory?.businessDetails?.pob,
    gstinState: changeHistory?.gstDetails?.state,
    premiseType: changeHistory?.businessDetails?.businessAddressType,
    addressLine1: changeHistory?.businessDetails?.businessAddress?.addressLine1,
    addressLine2: changeHistory?.businessDetails?.businessAddress?.addressLine2,
    pincode: changeHistory?.businessDetails?.businessAddress?.pinCode,
    city: changeHistory?.businessDetails?.businessAddress?.city,
    state: changeHistory?.businessDetails?.businessAddress?.state,
    businessWebsite: changeHistory?.otherBusinessDetails?.website,
    landlineNumber: changeHistory?.otherBusinessDetails?.landlineNumber,
    businessEmailId: changeHistory?.otherBusinessDetails?.emailId,
    dailyTransactionValue: changeHistory?.otherBusinessDetails?.dailyTransactionValue,
    dailyTransactionCount: changeHistory?.otherBusinessDetails?.dailyTransactionCount,
    //returnPolicy: changeHistory?.otherBusinessDetails?.returnPolicy,
    bankAccountHolderName: changeHistory?.settlementDetail?.beneficiaryName,
    settlementAccountNumber: changeHistory?.settlementDetail?.accountNumber,
    confirmSettlementAccountNumber: changeHistory?.settlementDetail?.accountNumber,
    ifscCode: changeHistory?.settlementDetail?.ifscCode,
    canceled_check_docs_data: changeHistory?.settlementDetail?.documents,
    settlementPlanId: changeHistory?.settlementDetail?.settlementPlanId,
    doc_upload_docs_data: changeHistory?.documents,
    feePackageId: changeHistory?.feePackage?.feePackageId,
    allowParentFeePackageId: changeHistory?.feePackage?.inheritParentFeePackage,
    listOfPrograms: changeHistory?.feePackage?.programs?.[0]?.programId,
    referenceId: changeHistory?.feePackage?.programs?.[0]?.programReferenceId,
    merchantRiskCategory: findRiskSettingValue(configMap, 'RISK_SETTING', 'MERCHANT_RISK'),
    allowParentIdSettlement: findRiskSettingValue(configMap, 'RISK_SETTING', 'ALLOW_PARENT_ID_SETTL_FLAG'),
    riskDeliveryPeriod: findRiskSettingValue(configMap, 'RISK_SETTING', 'DELIVERY_PERIOD'),
    riskDeferredDeliveryOptions: findRiskSettingValue(configMap, 'RISK_SETTING', 'MERCHANT_DAY_DELIVERY'),
    riskInternationalAcceptance: findRiskSettingValue(configMap, 'RISK_SETTING', 'INTERNATIONAL_ACCEPTANCE'),
    riskCurrentTnxLimit: findRiskSettingValue(limits, 'OPEN_LOOP_RISK', 'OPEN_LOOP_CURRENT_TRANSACTION_LIMIT'),
    riskCurrentExitLimit: findRiskSettingValue(limits, 'OPEN_LOOP_RISK', 'OPEN_LOOP_CURRENT_EXIT_LIMIT'),
    riskCurrentTnxCount: findRiskSettingValue(limits, 'OPEN_LOOP_RISK', 'OPEN_LOOP_CURRENT_TRANSACTION_COUNT'),
    risk_supporting_docs_data: changeHistory?.riskSettings?.documents,
    status: changeHistory?.status?.[0]?.statusCode,
    reasonCode: changeHistory?.status?.[0]?.reasonCode,
    reasonMessage: changeHistory?.status?.[0]?.reasonMessage,
  }
}

const parseDate = (input: any) => {
  // Check if input is a string and matches the yyyy-mm-dd format
  if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
    // Convert the string to a Date object
    const date = new Date(input)
    // Check if the date is valid
    if (!isNaN(date.getTime())) {
      return date.toString()
    }
  }

  // Return null or any other default value for invalid dates
  return ''
}

const getGlobalEntityQueue = (requestBody: any, ddListData: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getGlobalEntityQueue),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: requestBody,
  }

  return executeRequest(request)
    .then((resp) => entityListResponseParser(resp, ddListData))
    .catch((error) => {
      throw error
      //return responseParser(CHECKER_ONE_RESP, ddListData)
    })
}

export { getGlobalEntityQueue }
